// What other parts of the page tell the site header after it has rendered: the
// counters the socket pushes (ServerMessageController), the path client
// navigation moved to and, on /netplay, the app's in-place navigation and
// current path (NetplayHeaderBridge). The header
// reads it with useSyncExternalStore; the server render and the hydrating
// render read the empty state, so they match.

import { stripLocalePrefix } from 'i18n/urlLocale';

const EMPTY_STATE = Object.freeze({ counts: Object.freeze({}), navigateNetplay: null, path: null });

let state = EMPTY_STATE;
const listeners = new Set();

function update(nextState) {
	state = nextState;
	listeners.forEach((listener) => listener());
}

export function subscribeToSiteHeader(listener) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}

export function getSiteHeaderState() {
	return state;
}

export function getServerSiteHeaderState() {
	return EMPTY_STATE;
}

// Names: bugs, modNotifications, matchHelpRequests, flaggedMatches, banAppeals. A message without
// a count leaves the current one alone.
export function setHeaderCount(name, count) {
	if(count === undefined || count === null || state.counts[name] === count) {
		return;
	}
	update({ ...state, counts: { ...state.counts, [name]: count } });
}

// The header picks its section from the path without a locale prefix (/ja).
function pagePath(path) {
	return path ? stripLocalePrefix(path) : path;
}

// navigate(view) switches the netplay app to 'chat' or 'play'; null hands the
// links back to the browser. path overrides the path the page loaded with.
export function setNetplayNavigation(navigate, fullPath) {
	const path = pagePath(fullPath);
	if(state.navigateNetplay === navigate && state.path === path) {
		return;
	}
	update({ ...state, navigateNetplay: navigate, path });
}

// The path of the page client navigation (navigation/clientNavigator) swapped in.
export function setHeaderPath(fullPath) {
	const path = pagePath(fullPath);
	if(state.path === path) {
		return;
	}
	update({ ...state, path });
}

export function resetSiteHeaderState() {
	update(EMPTY_STATE);
}
